import { render } from "./rulesSection.vue?vue&type=template&id=3a785d54&scoped=true"
import script from "./rulesSection.vue?vue&type=script&lang=js"
export * from "./rulesSection.vue?vue&type=script&lang=js"

import "./rulesSection.vue?vue&type=style&index=0&id=3a785d54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a785d54"]])

export default __exports__